import { render, staticRenderFns } from "./Markup.vue?vue&type=template&id=38120687&scoped=true&"
import script from "./Markup.vue?vue&type=script&lang=js&"
export * from "./Markup.vue?vue&type=script&lang=js&"
import style0 from "./Markup.vue?vue&type=style&index=0&id=38120687&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38120687",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
